import {observable} from 'mobx';

export default class GroupScopeSettings {
	@observable is_shown = true;
	@observable show_in_stock_only = false;
	@observable show_on_primary_product_only = false;
	@observable show_header = true;
	@observable current_product_first = false;
	@observable image_size = '';

	constructor(settings) {
		if (settings) {
			this.is_shown = settings.is_shown;
			this.show_in_stock_only = settings.show_in_stock_only;
			this.show_on_primary_product_only = settings.show_on_primary_product_only;
			this.show_header = settings.show_header;
			this.current_product_first = settings.current_product_first;
			this.image_size = settings.image_size;
		}
	}
}